// extracted by mini-css-extract-plugin
export default {"wrapper":"numbers-carousel-module--wrapper--0e73b","number":"numbers-carousel-module--number--2cbd7","selected":"numbers-carousel-module--selected--ff922"};